import {
  ChannelSettingDropdown,
  type OverrideValue,
} from './ChannelSettingDropdown';

export function ChannelRecencyBiasSection({
  value,
  onValueChange,
  globalEnabled,
  isReadOnly = false,
}: {
  value: OverrideValue;
  onValueChange: (value: OverrideValue) => void;
  globalEnabled: boolean;
  isReadOnly?: boolean;
}) {
  return (
    <ChannelSettingDropdown
      title="Recency Bias"
      description="Override the team-wide setting for recency bias in this channel. When enabled, more recent documents are prioritized in search results."
      value={value}
      onValueChange={onValueChange}
      globalEnabled={globalEnabled}
      isReadOnly={isReadOnly}
    />
  );
}
